class MobileStickyBuy extends HTMLElement {
  connectedCallback() {
    const primaryBuyButtons = this.closest('.shopify-section')?.querySelector('.buy-buttons-block');
    if (!primaryBuyButtons) return;

    this.observer = new IntersectionObserver(
      ([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 320),
      { threshold: 0.05 }
    );
    this.observer.observe(primaryBuyButtons);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('mobile-sticky-buy')) {
  customElements.define('mobile-sticky-buy', MobileStickyBuy);
}
